import React, { useState } from "react";
import Downloadapp from "./Downloadapp";
import Security from "./Security";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Manubar from "./Manubar";
import "./loader.css";
import "./shubh.css";

const Contact_us = () => {
  const [mapLoading, setMapLoading] = useState(true);

  return (
    <div>
      {/* header section start */}

      {/* Mobile Menu Modal */}
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Navbar />
      </header>

      {/* Breadcrumb */}
      <nav className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Contact Us</li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      {/* Map Section */}
      <div className="map section-mb position-relative">
        
        {/* Loader */}
        {mapLoading && (
        <div
  className="modal-body d-flex flex-column justify-content-center align-items-center"
  style={{
    minHeight: "400px",
    position: "absolute",
    width: "100%",
    background: "#fff",
    zIndex: "10"
  }}
>
  <div
    className="spinner-border mb-4"
    style={{
      width: "50px",
      height: "50px",
      borderWidth: "8px",
      color: "#28a745"
    }}
    role="status"
  >
    <span className="visually-hidden">Loading...</span>
  </div>
</div>
        )}

        {/* Google Map */}
        <iframe
          title="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d64876600.99126343!2d-31.49658015000001!3d-7.0382327499999855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x65a81cae36eb8ff%3A0xa6342257f310534f!2sAtlantic%20Ocean!5e0!3m2!1sen!2sbd!4v1618893629132!5m2!1sen!2sbd"
          width="100%"
          height="400"
          style={{ border: 0 }}
          loading="lazy"
          onLoad={() => setMapLoading(false)}
        ></iframe>
      </div>

      {/* Contact Section */}
      <section className="contact-section section-mb">
        <div className="container">
          <div className="row mb-n7">
            
            {/* Contact Form */}
            <div className="col-lg-6 mb-7">
              <div className="contact-title-section">
                <h3 className="title">Get in touch</h3>
                <p>
                  Top rated construction packages we pleasure rationally encounter
                  consequences interesting who loves or pursue or desires
                </p>
              </div>

              <form className="row">
                <div className="col-12 col-sm-6 mb-7">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name*"
                  />
                </div>

                <div className="col-12 col-sm-6 mb-7">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Your Email*"
                  />
                </div>

                <div className="col-12 mb-9">
                  <textarea
                    className="form-control massage-control"
                    rows={8}
                    placeholder="Message"
                  ></textarea>
                </div>

                <div className="col-12">
                  <button type="submit" className="btn btn-dark">
                    Send Message
                  </button>
                </div>
              </form>
            </div>

            {/* Contact Address */}
            <div className="col-lg-6 mb-7">
              <div className="contact-address">

                <div className="address-list mb-4">
                  <h4 className="title">Office Address</h4>
                  <p>
                    245 Southern Street, Apartment no.174 Central Town,
                    New York, USA
                  </p>
                </div>

                <div className="address-list mb-4">
                  <h4 className="title">Phone Number</h4>
                  <ul>
                    <li>
                      <a className="phone-number" href="tel:+12345678987">
                        +12345 678 987
                      </a>
                    </li>
                    <li>
                      <a className="phone-number" href="tel:+98745612321">
                        +98745 612 321
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="address-list">
                  <h4 className="title">Web Address</h4>
                  <ul>
                    <li>
                      <a className="mailto" href="mailto:info@example.com">
                        info@example.com
                      </a>
                    </li>
                    <li>
                      <a className="mailto" href="https://www.example.com">
                        www.example.com
                      </a>
                    </li>
                  </ul>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      <Security />
      <Downloadapp />
      <Footer />
    </div>
  );
};

export default Contact_us;